import { useContext, useEffect, useState } from 'react';
import './mainScreen.css';
import { checkReportStatus, deleteReport, fetchGenerateReport, fetchRetrieveReport, fetchTrackersGroups, fetchUserDevices } from '../utils/requests';
import { Fuel, Mileage, Ralenti, SpeedViolation, StoppedTime } from './sections';
import { FuelIcon, MileageIcon, RalentiIcon, SpeedViolationIcon, StoppedTimeIcon, WorkingTimeIcon } from '../assets/icons';
import WorkingTime from './sections/workingTime';

import trackersGroupsJson from '../utils/trackersGroupsJson.json';
import devicesJson from '../utils/devices.json';
import reportJson from '../utils/dataReport.json';
import stopsDataJson from '../utils/stopsData.json'
import speedViolationJson from '../utils/speedViolation.json'
import engineDataJson from '../utils/engineData.json'
import fuelDataJson from '../utils/fuelReport.json'
import eventsDataJson from '../utils/eventsData.json';
import { Button, TextField, Tooltip } from '@mui/material';
import { exportToExcel } from '../utils/exportToExcel';
import Aside from './aside';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { DateContext } from '../context/dateProvider';

const MainScreen = ({ userHash, sectionOrder, devices, setDevices, trackersGroups, setTrackersGroups, isMobileDevicesVisible, setIsMobileDevicesVisible, userConstants, updateUserConstants, setNewOrder }) => {
    const { startDate, endDate, setStartDate, setEndDate } = useContext(DateContext);

    const [isRecoveredReports, setIsRecoveredReports] = useState(false);

    const [collapsedSections, setCollapsedSections] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [progressMileageReport, setProgressMileageReport] = useState(0);
    const [progressStopsReport, setProgressStopsReport] = useState(0);
    const [progressSpeedViolationReport, setProgressSpeedViolationReport] = useState(0);
    const [progressEngineReport, setProgressEngineReport] = useState(0);
    const [progressFuelReport, setProgressFuelReport] = useState(0);
    const [progressEventsReport, setProgressEventsReport] = useState(0);

    const [mileageError, setMileageError] = useState(false);
    const [stopsError, setStopsError] = useState(false);
    const [speedViolationError, setspeedViolationError] = useState(false);
    const [engineError, setEngineError] = useState(false);
    const [fuelError, setFuelError] = useState(false);
    const [eventsError, setEventsError] = useState(false);

    const [mileageData, setMileageData] = useState(null);
    const [stopsData, setStopsData] = useState(null);
    const [speedViolationData, setSpeedViolationData] = useState(null);
    const [engineData, setEngineData] = useState(null);
    const [fuelData, setFuelData] = useState(null);
    const [eventsData, setEventsData] = useState(null);

    const SECTIONS_MAP = {
        mileage: {
            component: Mileage,
            title: 'Kilometraje',
            icon: <MileageIcon />,
            data: mileageData,
            progress: progressMileageReport,
            description: 'Reporte de kilómetros recorridos por el vehículo.',
            error: mileageError,
            reportName: 'mileageData'
        },
        stoppedTime: {
            component: StoppedTime,
            title: 'Tiempo detenido',
            icon: <StoppedTimeIcon />,
            data: stopsData,
            progress: progressStopsReport,
            description: 'Duración en la que el vehículo estuvo sin moverse.',
            error: stopsError,
            reportName: 'stoppedTimeData'
        },
        speedViolation: {
            component: SpeedViolation,
            title: 'Excesos de velocidad',
            icon: <SpeedViolationIcon />,
            data: speedViolationData,
            progress: progressSpeedViolationReport,
            description: 'Tiempos en los que se superó el límite de velocidad permitido.',
            error: speedViolationError,
            reportName: 'speedViolationData'
        },
        ralenti: {
            component: Ralenti,
            title: 'Ralentí',
            icon: <RalentiIcon />,
            data: engineData,
            progress: progressEngineReport,
            description: 'Tiempo que el motor estuvo encendido mientras el vehículo no se movía.',
            error: engineError,
            reportName: 'ralentiData'
        },
        fuel: {
            component: Fuel,
            title: 'Combustible',
            icon: <FuelIcon />,
            data: fuelData,
            progress: progressFuelReport,
            description: 'Cantidad de combustible utilizado durante el trayecto.',
            error: fuelError,
            reportName: 'fuelData'
        },
        workingTime: {
            component: WorkingTime,
            title: 'Tiempo de trabajo',
            icon: <WorkingTimeIcon />,
            data: [mileageData, eventsData],
            progress: [progressMileageReport, progressEventsReport],
            description: 'Tiempo total que el vehículo estuvo en operación activa.',
            error: eventsError,
            reportName: ['workingTimeEventsData', 'workingTimeTripsData']
        },
    };

    const colorPalette = [
        "#36a2eb", "#fe6383", "#4ac0c0", "#ff9f40", "#9966ff", "#ffcc56", "#4dc9f6", "#f67019",
        "#f53794", "#537bc4", "#acc236", "#166a8f", "#00a950", "#8549ba", "#ff6f61", "#F39C12",
        "#6b5b95", "#88b04b", "#f7cac9", "#92a8d1", "#955251", "#b565a7", "#009b77", "#dd4124",
        "#d65076", "#45b8ac", "#e94b3c", "#5b5ea6", "#9b2335", "#55b4b0", "#efc050", "#e15d44",
        "#7fcdcd", "#bc243c", "#c3447a", "#f7786b", "#622569", "#f0e68c", "#34a853", "#16A085",
        "#d4af37", "#4169e1", "#b22222", "#f08080", "#4682b4", "#9370db", "#ff8c00", "#ffd700",
        "#ff4500", "#daa520", "#20b2aa", "#ff1493", "#FF5733", "#33FF57", "#3357FF", "#E74C3C",
        "#D35400", "#C0392B", "#27AE60", "#2C3E50", "#9B59B6", "#34495E", "#F1C40F", "#7F8C8D",
        "#BDC3C7", "#E67E22", "#1ABC9C", "#3498DB", "#A569BD", "#7D3C98", "#EC7063", "#8E44AD",
        "#D4AC0D", "#85929E", "#52BE80", "#5DADE2", "#AF7AC5", "#48C9B0", "#EDBB99", "#85C1E9",
        "#D7BDE2", "#82E0AA", "#F5B7B1", "#AED6F1", "#D5DBDB", "#7FB3D5", "#FAD7A0", "#B3B6B7",
        "#D98880", "#F0B27A", "#F7DC6F", "#ABB2B9", "#CCD1D1", "#ABEBC6", "#F9E79F", "#F8C471",
        "#2980B9",
    ];


    const isColorLight = (color) => {
        color = color.replace('#', '');
        const r = parseInt(color.substring(0, 2), 16);
        const g = parseInt(color.substring(2, 4), 16);
        const b = parseInt(color.substring(4, 6), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 128;
    };

    // Lista de plugins a procesar
    const plugins = [
        { plugin: { plugin_id: 4, show_seconds: true, include_summary_sheet: false, include_summary_sheet_only: false, split: true }, name: 'Reporte de viajes', setData: setMileageData, setProgress: setProgressMileageReport, setError: setMileageError },
        { plugin: { plugin_id: 6, show_seconds: true, hide_empty_tabs: true, show_coordinates: false, filter: false }, name: 'Reporte de paradas', setData: setStopsData, setProgress: setProgressStopsReport, setError: setStopsError },
        { plugin: { plugin_id: 27, show_seconds: true, hide_empty_tabs: true, filter: false, min_duration_minutes: 1, max_speed: 40, group_by_driver: false }, name: 'Reporte de violación de velocidad', setData: setSpeedViolationData, setProgress: setProgressSpeedViolationReport, setError: setspeedViolationError },
        { plugin: { plugin_id: 7, show_seconds: true, include_summary_sheet: false, include_summary_sheet_only: false, show_detailed: false, hide_empty_tabs: true, filter: false }, name: 'Reporte de datos del motor', setData: setEngineData, setProgress: setProgressEngineReport, setError: setEngineError },
        { plugin: { plugin_id: 10, show_seconds: true, graph_type: 'mileage', detailed_by_dates: true, include_summary_sheet: false, include_summary_sheet_only: false, use_ignition_data_for_consumption: false, include_mileage_plot: false, filter: false, include_speed_plot: false, smoothing: false, surge_filter: false, surge_filter_threshold: 0.19, speed_filter: false, speed_filter_threshold: 10 }, name: 'Reporte de combustible', setData: setFuelData, setProgress: setProgressFuelReport, setError: setFuelError },
        { plugin: { plugin_id: 11, show_seconds: true, hide_empty_tabs: true, group_by_type: false, event_types: ["input_change"] }, name: 'Reporte de eventos de ignición', setData: setEventsData, setProgress: setProgressEventsReport, setError: setEventsError },
    ];


    const loadData = async () => {
        if (userHash) {
            setIsLoading(true);
            try {
                const dataTrackersGroups = await fetchTrackersGroups(userHash);

                if (dataTrackersGroups?.list) {
                    setTrackersGroups(dataTrackersGroups.list);
                }

                const dataDevices = await fetchUserDevices(userHash);
                if (dataDevices?.list) {
                    const devicesWithColors = dataDevices.list.map((device, index) => {
                        const color = colorPalette[index % colorPalette.length];
                        return {
                            ...device,
                            color,
                            iconColor: isColorLight(color) ? '#000000' : '#f0f3f8',
                            visible: true,
                            type: '',
                            fuelType: 'magna',
                        };
                    });

                    setDevices(devicesWithColors);
                    const trackersArray = devicesWithColors.map((device) => device.id);

                    // Ejecutar cada reporte de forma secuencial
                    // for (const { plugin, name, setData, setProgress, setError } of plugins) {
                    //     try {
                    //         const reportData = await fetchGenerateReport(userHash, trackersArray, plugin, name);
                    //         if (reportData?.id) {
                    //             try {
                    //                 await checkReportStatus(
                    //                     userHash,
                    //                     reportData.id,
                    //                     async () => {
                    //                         try {
                    //                             const retrievedReport = await fetchRetrieveReport(userHash, reportData.id);
                    //                             setData(retrievedReport);
                    //                             setProgress(100);
                    //                             try {
                    //                                 await deleteReport(userHash, reportData.id);
                    //                             } catch (error) {
                    //                                 console.error(`Error al eliminar el reporte:`, error);
                    //                             }
                    //                         } catch (error) {
                    //                             setError(true);
                    //                         }
                    //                     },
                    //                     (percentReady) => setProgress(percentReady)
                    //                 );
                    //                 setError(false);
                    //             } catch (error) {
                    //                 setError(true);
                    //             }
                    //         }
                    //     } catch (error) {
                    //         // console.error(`Error generando el ${name}:`, error);
                    //         setError(true);
                    //     }
                    // }
                } else {
                    console.error('La respuesta no contiene dispositivos o tiene una estructura inesperada.', dataDevices);
                }
            } catch (error) {
                console.error('Error al cargar los datos:', error);
            } finally {
                setIsLoading(false);
            }
        }
    };
    useEffect(() => {
        loadData();
    }, [userHash]);


    // useEffect(() => {
    //     setIsLoading(false);
    //     setTrackersGroups(trackersGroupsJson.list);
    //     setDevices(devicesJson);
    //     // setMileageData(reportJson);
    //     // setStopsData(stopsDataJson);
    //     // setSpeedViolationData(speedViolationJson);
    //     // setEngineData(engineDataJson);
    //     // setFuelData(fuelDataJson);
    //     // setEventsData(eventsDataJson);
    //     // setProgressMileageReport(100);
    //     // setProgressEventsReport(100);
    //     // setProgressFuelReport(100);
    //     // setProgressEngineReport(100);
    //     // setProgressSpeedViolationReport(100);
    //     // setProgressStopsReport(100);
    //     // setFuelError(true);
    // }, []);

    const fetchReport = async (num) => {
        let period = endDate.diff(startDate, 'day') + 1;
        const adjustedStartDate = startDate.subtract(period, 'day');

        plugins[num].setError(false);
        try {
            const reportData = await fetchGenerateReport(userHash, devices.map((device) => device.id), new Date(adjustedStartDate), new Date(endDate), plugins[num].plugin, plugins[num].name);
            if (reportData?.id) {
                try {
                    await checkReportStatus(
                        userHash,
                        reportData.id,
                        async () => {
                            try {
                                const retrievedReport = await fetchRetrieveReport(userHash, reportData.id);
                                plugins[num].setData(retrievedReport);
                                plugins[num].setProgress(100);
                                try {
                                    await deleteReport(userHash, reportData.id);
                                } catch (error) {
                                    console.error(`Error al eliminar el reporte:`, error);
                                }
                            } catch (error) {
                                plugins[num].setError(true);
                            }
                        },
                        (percentReady) => plugins[num].setProgress(percentReady)
                    );
                } catch (error) {
                    plugins[num].setError(true);
                }
            }
        } catch (error) {
            // console.error(`Error generando el ${name}:`, error);
            plugins[num].setError(true);
        }
    }

    const updateDevices = (updatedDevices) => {
        setDevices(updatedDevices); // Actualiza el estado de devices
    };

    // Función para manejar el clic en el botón de colapsar
    const toggleCollapse = (sectionId) => {
        setCollapsedSections((prevState) => ({
            ...prevState,
            [sectionId]: !prevState[sectionId], // Cambiar el estado de la sección
        }));
    };

    const [showData, setShowData] = useState(false);
    const [dateError, setDateError] = useState(false);
    const today = dayjs().endOf('day');
    const validateDates = (newStartDate, newEndDate) => {
        if (newEndDate.isAfter(today)) {
            return "La fecha final no puede ser posterior a hoy";
        }
        if (newStartDate.isAfter(newEndDate)) {
            return "La fecha de inicio no puede ser posterior a la fecha final";
        }
        if (newEndDate.diff(newStartDate, 'day') > 30) {
            return "El periodo no puede superar los 30 días";
        }
        return "";
    };

    const handleStartDateChange = (newValue) => {
        const newStartDate = newValue.startOf('day');
        setStartDate(newStartDate);
        setDateError(validateDates(newStartDate, endDate));
    };

    const handleEndDateChange = (newValue) => {
        const newEndDate = newValue.endOf('day');
        setEndDate(newEndDate);
        setDateError(validateDates(startDate, newEndDate));
    };

    const setToday = () => {
        const today = dayjs();
        setStartDate(today.startOf('day'));
        setEndDate(today.endOf('day'));
        setDateError("");
    };

    const setLastWeek = () => {
        const today = dayjs();
        setStartDate(today.subtract(6, 'day').startOf('day'));
        setEndDate(today.endOf('day'));
        setDateError("");
    };

    const setLastMonth = () => {
        const today = dayjs();
        setStartDate(today.subtract(29, 'day').startOf('day'));
        setEndDate(today.endOf('day'));
        setDateError("");
    };

    const generateReports = async () => {
        if (!dateError) {
            setShowData(true);
            for (let index = 0; index < plugins.length; index++) {
                plugins[index].setProgress(0);
            }
            try {
                for (let index = 0; index < plugins.length; index++) {
                    await fetchReport(index);
                }
            } catch (error) {
                console.log(error)
            } finally {
                setStartDate(startDate);
                setEndDate(endDate);
                updateUserConstants({ "reports.foundReports": true, "reports.startDate": new Date(startDate).toISOString(), "reports.endDate": new Date(endDate).toISOString() });
            }
        }
    }
    
    return (
        <div className="main-screen_bg_container">
            <div className="main-screen_container">
                <Aside devices={devices} setDevices={setDevices} isLoading={isLoading} isMobileDevicesVisible={isMobileDevicesVisible} setIsMobileDevicesVisible={setIsMobileDevicesVisible} trackersGroups={trackersGroups} showData={showData} setShowData={setShowData} setIsRecoveredReports={setIsRecoveredReports} />
                <main className='main-screen_central_panel'>
                    {!showData ?
                        <div className='select_range_report_container'>
                            <h1>Generar reportes</h1>
                            <br />
                            <br />
                            <div className='date-picker-container'>
                                <h3>Establecer periodo para los reportes</h3>
                                <div>
                                    <Button onClick={setToday}>Hoy</Button>
                                    <Button onClick={setLastWeek}>Última Semana</Button>
                                    <Button onClick={setLastMonth}>Último Mes</Button>
                                </div>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div style={{ display: 'flex', gap: '1rem' }}>
                                        <DatePicker
                                            label="Fecha de Inicio"
                                            value={startDate}
                                            format="DD/MM/YYYY"
                                            onChange={(newValue) => handleStartDateChange(newValue)}
                                            maxDate={endDate}
                                            slotProps={{
                                                textField: {
                                                    error: !!dateError,
                                                    helperText: dateError,
                                                },
                                            }}
                                        />
                                        <DatePicker
                                            label="Fecha Final"
                                            value={endDate}
                                            format="DD/MM/YYYY"
                                            onChange={(newValue) => handleEndDateChange(newValue)}
                                            maxDate={endDate}
                                            slotProps={{
                                                textField: {
                                                    error: !!dateError,
                                                    helperText: dateError,
                                                },
                                            }}
                                        />
                                    </div>
                                </LocalizationProvider>
                                <Button variant='contained' onClick={generateReports} disabled={!!dateError}>Generar reportes</Button>
                            </div>
                            {userConstants.reports.foundReports && (
                                <><br />
                                    <br />
                                    <br />
                                    <div>
                                        <h3>Se encontraron reportes para el periodo de {new Date(userConstants.reports.startDate).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })} a {new Date(userConstants.reports.endDate).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })}</h3>
                                        <Button variant='contained' onClick={() => {
                                            setNewOrder();
                                            setIsRecoveredReports(true);
                                            setStartDate(dayjs(userConstants.reports.startDate));
                                            setEndDate(dayjs(userConstants.reports.endDate));
                                            setProgressMileageReport(100);
                                            setProgressStopsReport(100);
                                            setProgressSpeedViolationReport(100);
                                            setProgressEngineReport(100);
                                            setProgressFuelReport(100);
                                            setProgressEventsReport(100);
                                            setShowData(true);
                                        }}>Usar estos reportes</Button>
                                    </div>
                                </>
                            )}
                        </div>
                        :
                        <div className='main-screen_section_container'>

                            {sectionOrder.map((section) => {
                                const { component: SectionComponent, title, icon, data, progress, description, error, reportName } = SECTIONS_MAP[section.id];

                                return (
                                    <section key={section.id} id={`${section.id}_section`} className={`section_container ${collapsedSections[section.id] ? 'collapsed' : ''}`}>
                                        <div className="section_header_container">
                                            {/* <span className="material-symbols-outlined section_icon_header">{icon}</span> */}
                                            <span className="section_icon_header">{icon}</span>
                                            <span className="section_header">{title}</span>
                                            <Tooltip title={description} arrow slotProps={{
                                                tooltip: {
                                                    sx: {
                                                        fontSize: '0.8rem',
                                                        backgroundColor: '#333',
                                                        color: '#fff',
                                                        padding: '8px 15px',
                                                        borderRadius: '8px',
                                                    }
                                                }
                                            }}>
                                                <span className='material-symbols-outlined tooltip' style={{ fontSize: '1.5rem', color: 'var(--menu-primary-text)', cursor: 'default' }}>
                                                    help
                                                </span>
                                            </Tooltip>
                                            <div style={{ display: 'flex', gap: '0.5rem', marginLeft: 'auto' }}>
                                                <button className='download_button' style={{ visibility: progress < 100 ? 'hidden' : 'visible' }} onClick={() => {
                                                    if (data && !isRecoveredReports) {
                                                        exportToExcel(data, title, startDate, endDate);
                                                    } else if (isRecoveredReports && userConstants.reports && userConstants.reports.foundReports) {
                                                        if (title === 'Tiempo de trabajo') {
                                                            exportToExcel({ events: userConstants.reports[reportName[0]], trips: userConstants.reports[reportName[1]] }, title, startDate, endDate, true);
                                                        } else {
                                                            exportToExcel(userConstants.reports[reportName], title, startDate, endDate, true);
                                                        }
                                                    }
                                                }}>
                                                    <span className='material-symbols-outlined'>download</span>
                                                </button>
                                                <button className='collapse_section_button' onClick={() => toggleCollapse(section.id)}>
                                                    <span className='material-symbols-outlined'>keyboard_arrow_up</span>
                                                </button>
                                            </div>
                                        </div>
                                        <SectionComponent dataReport={data} devices={devices} updateDevices={updateDevices} progress={progress} error={error} fetchReport={fetchReport} userConstants={userConstants} updateUserConstants={updateUserConstants} isRecoveredReports={isRecoveredReports} />
                                    </section>
                                );
                            })}
                        </div>
                    }
                </main>
            </div>
        </div>
    );
};

export default MainScreen;
